// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2GiBS","colCheckbox":"styles_colCheckbox__5nujw"};